__webpack_require__.p = "//ut-static.udache.com/webx/entry/ut-league/online/";